// Filter persistence for Clientes (/clientes). See usePersistedFilters.

export var CUSTOMERS_FILTERS_KEY = 'clientes';

export var getDefaultCustomersFilters = function() {
  return {
    search: '',
    actived: 1,
    onlyNoRule: false,
  };
};

// Badge: only what differs from the defaults.
export var countActiveCustomersFilters = function(filters, defaults) {
  var base = defaults || getDefaultCustomersFilters();
  return (filters.actived !== base.actived ? 1 : 0) +
    (filters.onlyNoRule ? 1 : 0) +
    (filters.search ? 1 : 0);
};
